import About from "components/BreakfastEvent/about";
import Agenda from "components/BreakfastEvent/agenda";
import Faq from "components/BreakfastEvent/faq";
import Home from "components/BreakfastEvent/home";
import Navbar from "components/BreakfastEvent/Navbar";
// import NotFound from "components/BreakfastEvent/NotFound";
import Speakers from "components/BreakfastEvent/speakers";
import Sponsors from "components/BreakfastEvent/sponsors";
import Footer from "components/sections/home/HomeFooter";

const Event = () => {
  return (
    <div>
      <Navbar />
      {/* <NotFound /> */}
      <Home />
      <About />
      <Sponsors />
      <Speakers />
      <Agenda />
      <Faq />
      <Footer />
    </div>
  );
};

export default Event;
